import { Component } from '@angular/core';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ToastControllerService } from "../../../providers/toast-controller.service";
import { Toast508Service } from "../../../providers/toast-508.service";
import { TranslationLoaderService } from "../../../../../UI/src/app/shared/translation/translation-loader.service";

@Component({
  selector: 'page-privacyPolicy',
  templateUrl: 'privacy-policy.component.html'
})
export class PrivacyPolicyComponent {
 
  constructor(
    public navCtrl: NavController,
    private toastService: ToastControllerService,
    public events: Events,
    public loadingCtrl: LoadingController,
    private translationLoader: TranslationLoaderService,
    private translate: TranslateService,
    private toast508Service: Toast508Service
  ) {
  }

  ionViewDidLoad() {
  }  
 
}


// WEBPACK FOOTER //
// ./src/app/modules/privacy-policy/privacy-policy.component.ts